<template>
  <svg width="212" height="139" viewBox="0 0 212 139" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_9925_13677)">
      <path
        d="M72.6416 26.3994L156.65 48.7209C159.147 49.3844 160.639 51.9551 159.975 54.4525C159.312 56.9498 156.741 58.4412 154.244 57.7776L70.2352 35.4561L72.6416 26.3994Z"
        fill="#CFFDFF" stroke="#CFFDFF" stroke-width="0.319113" stroke-miterlimit="10"
      />
      <path
        d="M22.9913 57.9385C31.5842 57.9385 38.55 44.9685 38.55 28.9692C38.55 12.97 31.5842 0 22.9913 0C14.3985 0 7.43262 12.97 7.43262 28.9692C7.43262 44.9685 14.3985 57.9385 22.9913 57.9385Z"
        fill="#DAFEA4"
      />
      <path d="M32.5106 0H22.9917V57.9307H32.5106V0Z" fill="#DAFEA4" />
      <path
        d="M32.5104 57.9385C41.1032 57.9385 48.0691 44.9685 48.0691 28.9692C48.0691 12.97 41.1032 0 32.5104 0C23.9175 0 16.9517 12.97 16.9517 28.9692C16.9517 44.9685 23.9175 57.9385 32.5104 57.9385Z"
        fill="#102B09"
      />
      <path
        d="M88.9544 51.2293C95.7204 51.2293 101.205 41.2631 101.205 28.9692C101.205 16.6753 95.7204 6.70917 88.9544 6.70917C82.1885 6.70917 76.7036 16.6753 76.7036 28.9692C76.7036 41.2631 82.1885 51.2293 88.9544 51.2293Z"
        fill="#F8F8F8"
      />
      <path
        d="M36.745 51.2293C43.5109 51.2293 48.9958 41.2631 48.9958 28.9692C48.9958 16.6753 43.5109 6.70917 36.745 6.70917C29.979 6.70917 24.4941 16.6753 24.4941 28.9692C24.4941 41.2631 29.979 51.2293 36.745 51.2293Z"
        fill="#DAFEA4"
      />
      <path d="M88.9546 6.70135H36.7446V51.2215H88.9546V6.70135Z" fill="#DAFEA4" />
      <path d="M94.4032 0H84.8843V57.9307H94.4032V0Z" fill="#DAFEA4" />
      <path opacity="0.2" d="M74.9292 6.70135L42.4653 51.2293H74.9292V6.70135Z" fill="#102B09" />
      <path
        d="M84.8839 57.9385C93.4767 57.9385 100.443 44.9685 100.443 28.9692C100.443 12.97 93.4767 0 84.8839 0C76.2911 0 69.3252 12.97 69.3252 28.9692C69.3252 44.9685 76.2911 57.9385 84.8839 57.9385Z"
        fill="#DAFEA4"
      />
      <path
        d="M94.4029 57.9385C102.996 57.9385 109.962 44.9685 109.962 28.9692C109.962 12.97 102.996 0 94.4029 0C85.8101 0 78.8442 12.97 78.8442 28.9692C78.8442 44.9685 85.8101 57.9385 94.4029 57.9385Z"
        fill="#102B09"
      />
      <path
        d="M85.2188 57.9307H171.745C193.966 57.9307 212 75.9723 212 98.1857C212 120.407 193.958 138.441 171.745 138.441H85.2188V57.9307Z"
        fill="#00173B"
      />
      <path
        d="M4.57666 64.9901H85.5769C103.899 64.9901 118.772 79.8639 118.772 98.1856C118.772 116.507 103.899 131.381 85.5769 131.381H4.57666V64.9823V64.9901Z"
        fill="#F8F8F8"
      />
      <path d="M118.399 57.9307H0V64.9901H118.399V57.9307Z" fill="#00173B" />
      <path d="M118.399 131.389H0V138.448H118.399V131.389Z" fill="#00173B" />
      <path
        d="M12.8892 80.6266H49.2136" stroke="#160926" stroke-width="0.778324" stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M41.228 90.8226H107.44" stroke="#160926" stroke-width="0.778324" stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M76.9065 90.8227C76.4395 90.8227 75.7234 91.6322 75.451 91.9201C74.4314 93.0176 73.9333 94.4575 73.6531 95.9052C73.3417 97.5319 73.2016 99.1897 72.9214 100.816C72.8125 101.47 72.6023 102.132 72.3377 102.739C72.2054 103.042 72.0497 103.338 71.8707 103.611C71.7773 103.758 71.6995 103.937 71.248 104.366C72.9526 104.194 78.1362 100.451 78.1362 100.451L82.526 104.366C82.6271 104.459 83.3821 103.221 83.4444 103.12C83.9114 102.342 84.1527 101.571 84.3395 100.676C84.7131 98.9251 84.8454 97.1349 85.2034 95.3837C85.5069 93.9126 85.8961 92.2782 87.0714 91.243C87.2893 91.0562 87.5306 90.8927 87.803 90.8071C87.803 90.8071 76.8987 90.8071 76.8909 90.8071L76.9065 90.8227Z"
        fill="#160926"
      />
    </g>
    <defs>
      <clipPath id="clip0_9925_13677">
        <rect width="212" height="138.441" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
